/**
 * 정보마당 HTML 은 부모 페이지와 격리된 iframe 에서만 연다.
 * allow-scripts 와 allow-same-origin 을 같이 주면 올린 HTML 이 로그인 쿠키에 닿을 수 있다.
 */
export const INFO_FRAME_SANDBOX =
  'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-forms allow-modals'

export const INFO_FRAME_ALLOW = 'fullscreen'

const BRIDGE = `
(function () {
  function post(msg) {
    try { parent.postMessage(Object.assign({ source: 'info-html' }, msg), '*') } catch (err) {}
  }
  function foreignScript() {
    var nodes = document.getElementsByTagName('script')
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-info-bridge') === '1') continue
      if (nodes[i].src || (nodes[i].textContent || '').trim()) return true
    }
    return false
  }
  var authored = foreignScript()
  function labelOf(btn) {
    var strong = btn.querySelector('strong')
    return ((strong ? strong.textContent : btn.textContent) || '').replace(/\\s+/g, ' ').trim()
  }
  function showPanel(id) {
    var panels = document.querySelectorAll('[data-panel]')
    if (!panels.length) return
    panels.forEach(function (panel) {
      panel.classList.toggle('active', panel.getAttribute('data-panel') === id)
    })
    document.querySelectorAll('[data-go]').forEach(function (btn) {
      var on = btn.getAttribute('data-go') === id
      btn.classList.toggle('active', on)
      if (on) btn.setAttribute('aria-current', 'page')
      else btn.removeAttribute('aria-current')
    })
    var crumb = document.getElementById('crumbCurrent')
    var current = document.querySelector('[data-go].active')
    if (crumb && current) crumb.textContent = labelOf(current)
    var stage = document.getElementById('stage')
    if (stage) stage.scrollTop = 0
    setTimeout(measure, 40)
  }
  function showChoice(btn) {
    var value = btn.getAttribute('data-choice') || ''
    var group = btn.closest('[role="group"]') || btn.parentElement
    if (!group) return
    group.querySelectorAll('[data-choice]').forEach(function (el) {
      var on = el.getAttribute('data-choice') === value
      el.classList.toggle('chosen', on)
      el.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    var root = group.parentElement || document
    root.querySelectorAll('[data-answer]').forEach(function (panel) {
      panel.classList.toggle('show', panel.getAttribute('data-answer') === value)
    })
  }
  var typeSnap = null
  function captureType() {
    var title = document.getElementById('typeTitle')
    var text = document.getElementById('typeText')
    var chips = document.getElementById('typeChips')
    var active = document.querySelector('.type-btn.active, .type-btn[aria-pressed="true"]')
    if (!title || !active) return
    typeSnap = {
      key: active.getAttribute('data-type'),
      text: text ? text.textContent : '',
      chips: chips ? chips.innerHTML : ''
    }
  }
  function showType(btn) {
    var buttons = document.querySelectorAll('.type-btn')
    buttons.forEach(function (el) {
      var on = el === btn
      el.classList.toggle('active', on)
      el.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    var index = Array.prototype.indexOf.call(buttons, btn)
    var idEl = document.getElementById('typeId')
    if (idEl && index >= 0) {
      var n = function (v) { return (v < 10 ? '0' : '') + v }
      idEl.textContent = n(index + 1) + ' / ' + n(buttons.length)
    }
    var title = document.getElementById('typeTitle')
    var name = (btn.textContent || '').replace(/\\s+/g, ' ').trim()
    if (title) title.textContent = name
    var same = typeSnap && btn.getAttribute('data-type') === typeSnap.key
    var text = document.getElementById('typeText')
    var chips = document.getElementById('typeChips')
    var custom = btn.getAttribute('data-text')
    if (text) text.textContent = custom || (same && typeSnap ? typeSnap.text : name)
    if (chips) {
      if (same && typeSnap) chips.innerHTML = typeSnap.chips
      else chips.textContent = ''
    }
  }
  function paintCheck(item, value) {
    item.querySelectorAll('[data-val]').forEach(function (btn) {
      var on = !!value && btn.getAttribute('data-val') === value
      btn.classList.toggle('selected', on)
      btn.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    var label = value === 'ready' ? '준비 완료' : value === 'review' ? '확인 필요' : value === 'fix' ? '개선 필요' : ''
    if (label) item.setAttribute('data-print-state', label)
    else item.removeAttribute('data-print-state')
  }
  function refreshProgress() {
    var items = document.querySelectorAll('[data-check]')
    if (!items.length) return
    var ready = 0
    var review = 0
    var fix = 0
    var picked = 0
    var map = {}
    items.forEach(function (item) {
      var on = item.querySelector('[data-val].selected')
      var key = item.getAttribute('data-check')
      if (!on || !key) return
      var value = on.getAttribute('data-val') || ''
      map[key] = value
      picked += 1
      if (value === 'ready') ready += 1
      else if (value === 'review') review += 1
      else if (value === 'fix') fix += 1
    })
    var count = document.getElementById('readyCount')
    var summary = document.getElementById('checkSummary')
    var bar = document.getElementById('readyBar')
    if (count) count.textContent = ready + ' / ' + items.length + ' 준비 완료'
    if (summary) {
      summary.textContent = picked
        ? '준비 완료 ' + ready + ' · 확인 필요 ' + review + ' · 개선 필요 ' + fix
        : '아직 선택된 항목이 없습니다.'
    }
    if (bar) bar.style.width = Math.round((ready / items.length) * 100) + '%'
    post({ kind: 'checks', map: map })
  }
  function applyChecks(map) {
    document.querySelectorAll('[data-check]').forEach(function (item) {
      var key = item.getAttribute('data-check') || ''
      paintCheck(item, key && map[key] ? map[key] : '')
    })
    var items = document.querySelectorAll('[data-check]')
    if (!items.length) return
    var ready = 0
    var review = 0
    var fix = 0
    var picked = 0
    items.forEach(function (item) {
      var on = item.querySelector('[data-val].selected')
      if (!on) return
      picked += 1
      var value = on.getAttribute('data-val')
      if (value === 'ready') ready += 1
      else if (value === 'review') review += 1
      else if (value === 'fix') fix += 1
    })
    var count = document.getElementById('readyCount')
    var summary = document.getElementById('checkSummary')
    var bar = document.getElementById('readyBar')
    if (count) count.textContent = ready + ' / ' + items.length + ' 준비 완료'
    if (summary) {
      summary.textContent = picked
        ? '준비 완료 ' + ready + ' · 확인 필요 ' + review + ' · 개선 필요 ' + fix
        : '아직 선택된 항목이 없습니다.'
    }
    if (bar) bar.style.width = Math.round((ready / items.length) * 100) + '%'
  }
  function openExternal(href) {
    if (/^https?:/i.test(href) || href.indexOf('//') === 0) {
      var url = href.indexOf('//') === 0 ? 'https:' + href : href
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }
    post({ kind: 'open', href: href })
  }
  function toggleScreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen()
      return
    }
    var node = document.documentElement
    var pending = node.requestFullscreen ? node.requestFullscreen() : null
    if (pending && pending.catch) pending.catch(function () { post({ kind: 'fullscreen' }) })
    else post({ kind: 'fullscreen' })
  }
  document.addEventListener('click', function (event) {
    var target = event.target
    if (!target || !target.closest) return
    var link = target.closest('a[href]')
    if (link) {
      var href = (link.getAttribute('href') || '').trim()
      if (!href || /^\\s*javascript:/i.test(href)) {
        event.preventDefault()
        return
      }
      if (href.charAt(0) === '#') {
        var id = href.slice(1)
        try { id = decodeURIComponent(id) } catch (err) {}
        var anchor = id ? document.getElementById(id) : null
        if (!anchor) return
        event.preventDefault()
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
      event.preventDefault()
      openExternal(href)
      return
    }
    if (target.closest('#fullBtn')) {
      if (authored) return
      event.preventDefault()
      toggleScreen()
      return
    }
    if (authored) return
    var choice = target.closest('[data-choice]')
    if (choice) showChoice(choice)
    var valBtn = target.closest('[data-val]')
    if (valBtn) {
      var item = valBtn.closest('[data-check]')
      if (item) {
        var value = valBtn.getAttribute('data-val') || ''
        paintCheck(item, valBtn.classList.contains('selected') ? '' : value)
        refreshProgress()
      }
    }
    var go = target.closest('[data-go]')
    if (go) {
      showPanel(go.getAttribute('data-go') || '')
      setTimeout(measure, 40)
    }
    var typeBtn = target.closest('.type-btn[data-type]')
    if (typeBtn) {
      showType(typeBtn)
      setTimeout(measure, 40)
    }
    var plain = target.closest('button')
    if (!plain) return
    var label = (plain.textContent || '').replace(/\\s+/g, ' ')
    if (label.indexOf('인쇄') >= 0) {
      event.preventDefault()
      window.print()
      return
    }
    if (label.indexOf('초기화') >= 0) {
      event.preventDefault()
      document.querySelectorAll('[data-check]').forEach(function (item) { paintCheck(item, '') })
      refreshProgress()
    }
  }, true)
  function markSpy() {
    var links = document.querySelectorAll('.side a[href^="#"]')
    var sections = document.querySelectorAll('[data-spy]')
    if (!links.length || !sections.length) return
    var current = sections[0].id
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top <= 120) current = sections[i].id
    }
    for (var j = 0; j < links.length; j++) {
      links[j].classList.toggle('on', links[j].getAttribute('href') === '#' + current)
    }
  }
  function stepPanel(dir) {
    var buttons = document.querySelectorAll('[data-go]')
    if (!buttons.length) return
    var index = 0
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].classList.contains('active')) index = i
    }
    var next = index + dir
    if (next < 0 || next >= buttons.length) return
    showPanel(buttons[next].getAttribute('data-go') || '')
  }
  document.addEventListener('keydown', function (event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    var tag = event.target && event.target.tagName
    if (tag === 'INPUT' || tag === 'TEXTAREA' || (event.target && event.target.isContentEditable)) return
    if (!authored && (event.key === 'ArrowRight' || event.key === 'ArrowLeft') && document.querySelector('[data-panel]')) {
      event.preventDefault()
      stepPanel(event.key === 'ArrowRight' ? 1 : -1)
      return
    }
    if (event.key !== 'f' && event.key !== 'F') return
    if (!document.getElementById('fullBtn') && !document.querySelector('[data-panel]')) return
    event.preventDefault()
    toggleScreen()
  })
  window.addEventListener('message', function (event) {
    var data = event.data || {}
    if (!data || data.source !== 'info-html-host') return
    if (data.kind === 'measure') measure()
    if (data.kind === 'checks' && data.map) applyChecks(data.map)
    if (data.kind === 'focus' && data.id) {
      var el = document.getElementById(String(data.id))
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  })
  function releaseClip() {
    if (document.getElementById('info-html-fit')) return
    var style = document.createElement('style')
    style.id = 'info-html-fit'
    style.textContent = 'html,body,.shell,.main,.stage{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}.panel.active{height:auto!important;min-height:0!important;overflow:visible!important}'
    ;(document.head || document.documentElement).appendChild(style)
  }
  function measure() {
    var root = document.documentElement
    var body = document.body
    var height = Math.max(
      root ? root.scrollHeight : 0,
      body ? body.scrollHeight : 0,
      root ? root.offsetHeight : 0,
      body ? body.offsetHeight : 0
    )
    if (height > 0) post({ kind: 'height', height: height })
  }
  function watchSize() {
    measure()
    document.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return
      img.addEventListener('load', measure, { once: true })
      img.addEventListener('error', measure, { once: true })
    })
    if (window.ResizeObserver && document.body) new ResizeObserver(measure).observe(document.body)
    window.addEventListener('load', measure)
    window.addEventListener('resize', measure)
    document.addEventListener('fullscreenchange', measure)
    setTimeout(measure, 400)
    setTimeout(measure, 1200)
  }
  releaseClip()
  if (!authored) {
    captureType()
    if (document.querySelector('[data-panel]') && !document.querySelector('[data-panel].active')) showPanel('0')
    if (document.querySelector('[data-spy]')) {
      document.addEventListener('scroll', markSpy, true)
      window.addEventListener('resize', markSpy)
      markSpy()
    }
  }
  watchSize()
  post({ kind: 'ready' })
})()
`

function fragmentDocument(content: string, css: string) {
  return `<!DOCTYPE html><html lang="ko"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style>${css}</style></head><body>${content}</body></html>`
}

export function renderInfoHtmlDocument(html: string, options?: { fragmentCss?: string; live?: boolean }) {
  const content = html || ''
  const css =
    options?.fragmentCss ||
    ":root{color-scheme:light}body{margin:0;padding:24px;font-family:'Noto Sans KR','Apple SD Gothic Neo',system-ui,sans-serif;line-height:1.85;color:#1b1f27;word-break:keep-all}img{max-width:100%;height:auto}table{border-collapse:collapse}"
  let doc = /<\s*(!doctype|html)\b/i.test(content) ? content : fragmentDocument(content, css)
  if (options?.live === false || doc.includes('data-info-bridge="1"')) return doc
  const script = `<script data-info-bridge="1">${BRIDGE}</script>`
  const end = doc.toLowerCase().lastIndexOf('</body>')
  if (end >= 0) return `${doc.slice(0, end)}${script}${doc.slice(end)}`
  return `${doc}${script}`
}

export interface InfoHtmlDocRef {
  id: string
  title: string
}

export type InfoHtmlHref =
  | { kind: 'external'; href: string }
  | { kind: 'doc'; id: string; hash: string }
  | { kind: 'missing'; message: string }

function decodePart(value: string) {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

function sameName(left: string, right: string) {
  return left.trim().toLowerCase() === right.trim().toLowerCase()
}

export function resolveInfoHtmlHref(
  href: string,
  docs: ReadonlyArray<InfoHtmlDocRef>,
  currentId: string,
): InfoHtmlHref | null {
  const raw = href.trim()
  if (!raw || /^\s*javascript:/i.test(raw) || /^data:/i.test(raw)) return null
  if (/^(https?:|mailto:|tel:)/i.test(raw) || raw.startsWith('//')) {
    return { kind: 'external', href: raw.startsWith('//') ? `https:${raw}` : raw }
  }
  const hashAt = raw.indexOf('#')
  const hash = hashAt >= 0 ? decodePart(raw.slice(hashAt + 1)) : ''
  const path = (hashAt >= 0 ? raw.slice(0, hashAt) : raw).split('?')[0] || ''
  const file = decodePart(path.split('/').filter(Boolean).pop() || '')
  if (!file) {
    if (hash && currentId) return { kind: 'doc', id: currentId, hash }
    return null
  }
  if (/\.pdf$/i.test(file)) {
    return { kind: 'missing', message: '연결된 PDF는 정보마당에 올라와 있지 않습니다.' }
  }
  const stem = file.replace(/\.(html?|htm)$/i, '')
  const found = docs.find(
    (doc) => sameName(doc.title, stem) || sameName(doc.title, file) || sameName(doc.id, stem),
  )
  if (!found) return { kind: 'missing', message: '연결된 HTML 문서를 찾지 못했습니다.' }
  return { kind: 'doc', id: found.id, hash }
}
